import { BaseElement } from 'base';

const DEMO_WORK_MS = 1200;

class DesignGuideInput extends BaseElement {
  onConnect() {
    this.#bindSpecimens();
  }

  async #bindSpecimens() {
    await customElements.whenDefined('text-field');
    await customElements.whenDefined('action-button');
    if (!this.isConnected) return;

    this.qa('[data-demo-clear] text-field').forEach(field =>
      field.run(() => field.clear())
    );

    this.qa('[data-demo-async] text-field').forEach(field =>
      field.button?.confirmAction({
        onChange: () =>
          new Promise(resolve => setTimeout(resolve, DEMO_WORK_MS))
      })
    );
  }
}

if (!customElements.get('design-guide-input')) {
  customElements.define('design-guide-input', DesignGuideInput);
}
